import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/solicitudes-tipos-de-parametros';

/**
 * GET Parametros de Solicitudes
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getParametrosDeSolicitudes = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Parametro de Solicitudes
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getParametroDeSolicitud = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Parametro de Solicitudes
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postParametroDeSolicitud = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Parametro de Solicitudes
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchParametroDeSolicitud = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Parametro de Solicitudes
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteParametroDeSolicitud = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
